/**
 * Created by mateimisarca on 24/09/2020
 */

import Pagination from './pagination';

export default Pagination;
